<template>
    <div>
      <h4>{{ $t('advanced.ai_panel_placeholder') }}</h4>
    </div>
  </template>
  <script>
  export default { name: "AiPanel" }
  </script>
  